import React, { useEffect, useState } from "react";
import Loader from "../../Overview/Loader";
import { getModuleAndLookupDataAndFields } from "./Functions/helperFunctions";
import MuiTextField from "./MuiTextField";

function DynamicHashTextField({
  module,
  fields = [],
  savedData,
  initialValue,
}) {
  const [moduleFields, setModuleFields] = useState(fields);

  useEffect(() => {
    async function fetchData() {
      if (module && module !== "" && fields?.length == 0) {
        async function getRecordAndFieldData() {
          try {
            const entityDataAndFields = await getModuleAndLookupDataAndFields(
              module
            );
            let allFieldsData = [];
            Object.keys(entityDataAndFields?.fieldNames).forEach((module) => {
              allFieldsData = [
                ...allFieldsData,
                ...entityDataAndFields?.fieldNames[module],
              ];
            });
            console.log({ allFieldsData });
            setModuleFields((prev) => allFieldsData);
          } catch (error) {}
        }
        await getRecordAndFieldData();
      }
    }
    fetchData();
  }, [module]);

  if (!moduleFields?.length) {
    return <Loader height="5vh" message={""}/>;
  }

  return (
    <MuiTextField
      moduleFields={moduleFields}
      savedData={savedData}
      initialValue={initialValue}
    />
  );
}

export default DynamicHashTextField;
